import { ICommonTranslations } from '@/translations/default/common';

const common: Partial<ICommonTranslations> = {
  events: 'Veranstaltungen',
  exhibitors: 'Aussteller',
  exhibitor: 'Aussteller',
  remove: 'Entfernen',
  edit: 'Bearbeiten',
  create: 'Erstellen',
  delete: 'Löschen',
  name: 'Name',
  name_placeholder: 'Geben Sie Ihren Namen ein',
  email: 'E-Mail',
  invalid_email: 'Diese E-Mail ist ungültig',
  description: 'Beschreibung',
  category: 'Kategorie',
  model: 'Modell',
  save: 'Speichern',
  download: 'Herunterladen',
  upload: 'Hochladen',
  change: 'Veränderung',
  apply: 'Anwenden',
  empty_field_not_allowed: 'Dieses Feld darf nicht leer sein.',
  next: 'Nächste',
  previous: 'Bisherige',
  close: 'Schließen',
  cancel: 'Abbrechen',
  confirm: 'Bestätigen',
  search: 'Suche',
  mandatory_field: 'Dieses Feld ist verpflichtend.',
  name_in_use: 'Name bereits vergeben.',
  crop: 'Zuschneiden',
  published: 'Veröffentlicht',
  not_published: 'Unveröffentlicht',
  all: 'Alle',
  empty_list: 'Keine Daten verfügbar',
  user_chat_failed: 'Konnte Chat mit diesem User nicht öffnen',
  activity_center: 'Activity-Center',
  no_recent_activity: 'Keine aktuelle Aktivität',
  unread_messages: 'Ungelesene Nachrichten',
  reply: 'Antworten',
  session_invitations: 'Unbeantwortete Einladungen',
  accept: 'Akzeptieren',
  refuse: 'Ablehnen',
  in_progress: 'In Bearbeitung',
  recent_files: 'Letzte Dateien',
  open_conversations: 'Offene Konversationen',
  all_fields_required: 'Alle Felder erforderlich',
  something_went_wrong: 'Etwas ist schiefgelaufen',
  already_exists: 'Existiert bereits',
  profile: 'Mein Konto',
  filter_by_status: 'Nach Status filtern',
  open_meeting: 'Offenes Meeting ',
  visitors: 'Besucher',
  saved: 'Gespeichert',
  back: 'Zurück',
  session_full: 'Sitzung ist voll',
  file_not_image: 'Diese Datei ist kein Bild',
  new_export: 'Neuer Export',
  state: 'Status',
  details: 'Details',
  see_more: 'Mehr sehen',
  manage: 'Verwalten',
  see_as_visitor: 'Als Besucher ansehen',
  see_as_exhibitor: 'Als Aussteller ansehen',
  manage_visitors: 'Besucher verwalten',
  manage_exhibitors: 'Aussteller verwalten',
  manage_event: 'Veranstaltung verwalten',
  registered: 'registriert',
  refused: 'abgelehnt',
  pending: 'ausstehend',
  accepted: 'akzeptiert',
  favorites: 'Favoriten',
  add_to_favorites: 'Add to favorites',
  remove_from_favorites: 'Remove from favorites',
  contact_request: 'Contact request',
  invited: 'Invited',
  note: 'Note',
  discard: 'Verwerfen',
  no_comment: 'Kein Kommentar',
  click_here: 'Hier klicken',
  sessions: 'Sitzungen',
  event_sessions: 'Ereignissitzungen',
  exhibitor_sessions: 'Ausstellersitzungen',
  networking: 'Vernetzung',
  total: 'Gesamt',
  update_success: 'Informationen erfolgreich aktualisiert',
  agree_to_terms:
    'Stimmen Sie <a href="https://beamian.com/terms/" target="_blank"><b>beamian Geschäftsbedingungen zu</b></a>',
  add_to_calendar: 'Zu Ihrem Kalender hinzufügen',
  event_already_started: 'Dieses Ereignis hat bereits begonnen',
  countdown: 'Countdown',
  please_check_answers: 'Bitte überprüfen Sie Ihre Antworten',
  sort_by: 'Sortieren nach',
  order: 'Reihenfolge',
  date: 'Datum',
  ascending: 'Aufsteigend',
  descending: 'Absteigend',
  no_data_title: 'Hier gibt es nichts zu sehen!',
  no_data_subtitle: 'Bitte kommen Sie später wieder.',
  exhibitor_interactions: 'Aussteller-Interaktionen',
  interactions: 'Interaktionen',
  product_interactions: 'Produktinteraktionen',
  sessions_subtitle: 'Neueste Daten zu Sitzungszahlen und Statistiken',
  online_registrations: 'Online-Registrierungen',
  in_person_registrations: 'Persönliche Registrierungen',
  contacts: 'Kontakte',
  created: 'Erstellt',
  seeing_as_visitor: 'Ereignis als Besucher sehen',
  total_sessions: 'Sitzungen insgesamt',
};

export default common;
